import React, { useContext } from 'react'

import { ItemCardVariant } from '../ItemCard'

import TextButton from 'components/Luxkit/Button/TextButton'
import Group from 'components/utils/Group'
import SaveTripItemButton from 'tripPlanner/components/Buttons/SaveTripItemButton'
import ViewMoreOffersCta from 'tripPlanner/components/Buttons/ViewMoreOffersCta'
import RestoreCartButtons from 'tripPlanner/components/ItemCard/Common/RestoreCartButtons'
import { VIEW_OFFER_COPY } from 'tripPlanner/config'
import TripContext from 'tripPlanner/contexts/TripContext'
import { HomeAndVillasItem, HotelItem } from 'tripPlanner/types/tripItem'
import { itemSectionId } from 'tripPlanner/utils/itemSection'

interface Props {
  item:
    | Utils.RequiredProp<HotelItem, 'savedItemData'>
    | Utils.RequiredProp<HomeAndVillasItem, 'savedItemData'>
  isOfferAvailable: boolean
  variant: ItemCardVariant
}

export default function PlannedHotelCtaContent(props: Props) {
  const { isOfferAvailable, item } = props
  const { startDate: checkIn, endDate: checkOut, code: offerId } = item

  const tripContext = useContext(TripContext)
  const viewAsTemplate = tripContext?.viewAsTemplate
  const isPublicTrip = tripContext?.isPublicTrip

  if (viewAsTemplate || isPublicTrip) {
    return (
      <Group direction="horizontal" gap={12}>
        <SaveTripItemButton item={item} />
        <TextButton kind="primary" nonInteractable>
          {VIEW_OFFER_COPY}
        </TextButton>
      </Group>
    )
  } else if (!isOfferAvailable) {
    const hasPlannedInfo = !!checkIn || !!checkOut

    return (
      <Group
        direction="horizontal"
        gap={8}
        tabletHorizontalAlign="space-between"
        horizontalAlign="stretch"
      >
        {hasPlannedInfo && (
          <TextButton kind="tertiary" nonInteractable>
            Change details
          </TextButton>
        )}
        <ViewMoreOffersCta
          offerId={offerId}
          checkIn={checkIn}
          checkOut={checkOut}
          sectionId={itemSectionId(item.id)}
          tripId={item.tripId}
          showSearch={props.variant === 'tripSummary'}
        />
      </Group>
    )
  } else {
    return <RestoreCartButtons item={item} variant={props.variant} />
  }
}
